import "./BreakView.scss";

export const BreakView = () => (
  <div className="c-break-view">
    <span>...</span>
  </div>
);
